module.exports = __webpack_public_path__ + "static/media/RedCall.cca78993.svg";